import React, { useCallback, useEffect, useRef } from 'react';
import { Popover } from 'reactstrap';

const HeaderAnchorPopover = ({
  targetId,
  panelId,
  isOpen,
  toggle,
  popperClassName,
  children,
}) => {
  const wasOpen = useRef(false);
  const closeReason = useRef(null);

  const handleToggle = useCallback(
    (event) => {
      if (
        event &&
        event.type === 'click' &&
        event.target &&
        event.target.closest &&
        event.target.closest('.swal2-container')
      ) {
        return;
      }
      if (event && event.key === 'Escape') {
        closeReason.current = 'escape';
      }
      toggle(event);
    },
    [toggle],
  );

  useEffect(() => {
    if (!isOpen) {
      if (wasOpen.current && closeReason.current === 'escape') {
        const trigger = document.getElementById(targetId);
        if (trigger) trigger.focus();
      }
      closeReason.current = null;
      wasOpen.current = false;
      return undefined;
    }

    wasOpen.current = true;
    const panel = document.getElementById(panelId);
    if (panel) panel.focus();

    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      const trigger = document.getElementById(targetId);
      const panelNode = document.getElementById(panelId);
      if (trigger && (event.target === trigger || trigger.contains(event.target))) return;
      if (panelNode && panelNode.contains(event.target)) return;
      handleToggle(event);
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, handleToggle, targetId, panelId]);

  return (
    <Popover
      target={targetId}
      isOpen={isOpen}
      toggle={handleToggle}
      trigger="legacy"
      placement="bottom-end"
      hideArrow
      fade={false}
      container="body"
      positionFixed
      offset="0, 8"
      boundariesElement="viewport"
      modifiers={{
        preventOverflow: { boundariesElement: 'viewport', padding: 16 },
      }}
      popperClassName={popperClassName}
      innerClassName="dc-production-popover-inner"
    >
      {typeof children === 'function' ? children(handleToggle) : children}
    </Popover>
  );
};

export default HeaderAnchorPopover;
